<template>
  <va-edit-layout>
    <series-form :id="id" :title="title" :item="item"></series-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
